import { useState } from "react";

export const faqs: { q: string; a: string }[] = [
  {
    q: "每日爆料是什么？内容多久更新一次？",
    a: "每日爆料是一个以即时快讯为核心的中文资讯门户，聚焦娱乐、社会、财经、科技、体育等热门领域的每日最新爆料。我们保持全天候滚动更新，刚刚发生的重要事件会第一时间在首页快讯流与各栏目中呈现。",
  },
  {
    q: "你们的信息来源可靠吗？如何保证准确性？",
    a: "我们始终坚持来源优先、多方核实的原则。对时效性要求高的事件，我们会标注进展状态并持续跟进；对存在争议的信息，会在标题与正文中如实说明，不夸大、不臆断，并在有新进展时及时更新修正。",
  },
  {
    q: "我掌握了一条线索，可以怎样投稿？",
    a: "欢迎通过底部或投稿专区提供的爆料邮箱与我们联系，尽量提供时间、地点、人物等关键细节及可核实的佐证材料。我们会对每一条线索认真评估，并在刊发前征得你的同意，同时对爆料人信息严格保密。",
  },
  {
    q: "网站上的内容可以转载或引用吗？",
    a: "若需转载我们的原创报道，请保留来源与作者署名并联系我们取得授权；引用观点时请注明出处。未经许可对原创内容进行洗稿、搬运或断章取义使用，我们保留追责权利。",
  },
  {
    q: "发现某条报道有误，如何反馈更正？",
    a: "如果你发现内容存在事实性错误，请将出错的标题、链接及更正依据发送至客服邮箱，我们核实后会尽快在正文中标明更正说明，并及时同步相关平台。感谢你帮助我们把内容做得更严谨。",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);
  const toggle = (i: number) => setOpen(open === i ? -1 : i);

  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1">
            <div className="lg:sticky lg:top-28">
              <div className="flex items-center gap-3">
                <span className="w-1.5 h-6 rounded-full bg-accent-500 inline-block"></span>
                <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">常见问题</h2>
              </div>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                关于每日爆料的来源、更新、投稿、转载与纠错，这里汇总了读者最常问到的问题。如果仍有疑问，欢迎随时联系我们。
              </p>
              <a
                href="mailto:baoliao@meiribaoliao.cn"
                className="mt-5 inline-flex items-center gap-2 text-sm text-primary-700 hover:text-primary-600 font-medium"
              >
                <i className="ri-chat-smile-3-line text-lg"></i>还有问题？发邮件告诉我们
              </a>
            </div>
          </div>

          <div className="lg:col-span-2 space-y-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={i}
                  className={`bg-background-50 border rounded-lg overflow-hidden transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => toggle(i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className={`font-heading text-[15px] font-bold ${isOpen ? "text-primary-700" : "text-foreground-900"}`}>
                      {f.q}
                    </span>
                    <span className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${isOpen ? "bg-primary-600 text-background-50 rotate-180" : "bg-background-100 text-foreground-600"}`}>
                      <i className="ri-arrow-down-s-line text-lg"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 text-sm text-foreground-700 leading-relaxed fade-up">{f.a}</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}